import type { NotificationBlock } from './types'

export function fieldValue(block: NotificationBlock, name: string): string | undefined {
  return block.fields.find((field) => field.name === name)?.value
}
